"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUnavailabilityCategoryOptions = void 0;
const const_1 = require("@app/const");
const util_1 = require("@app/util");
const maybe_unwrap_1 = require("@app/util/apollo/maybe-unwrap");
const use_plugin_1 = require("@app/util/hooks/use-plugin");
const use_workspace_unavailability_categories_1 = require("@app/util/hooks/use-workspace-unavailability-categories");
const useWorkspace_1 = require("@app/util/hooks/useWorkspace");
const react_1 = __importDefault(require("react"));
const useUnavailabilityCategoryOptions = (isEmployeeCalendar, isRequest) => {
    const workspace = (0, useWorkspace_1.useWorkspace)();
    const { isPreventedByPlugin } = (0, use_plugin_1.usePlugin)();
    const { canWrite } = (0, util_1.useAccessRole)();
    const options = react_1.default.useMemo(() => {
        const unavCategories = (0, use_workspace_unavailability_categories_1.getWorkspaceUnavailabilityCategories)(workspace);
        const availableCategories = unavCategories
            .filter((cat) => (cat.employeeCanRequest && isEmployeeCalendar) || !isEmployeeCalendar)
            .map((cat) => ({
            value: cat.id,
            label: `${cat.tag && cat.tag.trim() !== '' && cat.tag !== (0, util_1.t)('UNAV_CAT_NO_TAG') ? cat.tag + ' - ' : ''} ${cat?.name ?? ''} ${cat.customId ? `(ID: ${cat?.customId ?? ''})` : ''}`.trim(),
            isVacation: cat.vacation,
            archived: cat.archived,
            groupTitle: (0, maybe_unwrap_1.unwrapMaybe)((0, util_1.isUndefined)(cat.available) ? (0, util_1.t)('TIMEOFFS') : (0, util_1.t)('TIME_PREFERENCES')),
        }));
        // let availableCategories = unavCategories
        //   .filter((cat) => cat.employeeCanRequest !== false || !isEmployeeCalendar)
        //   .map((cat) => ({
        //     value: cat.id || (cat.available ? 'availability' : 'unavailability'),
        //     label:
        //       `${cat.tag && cat.tag.trim() !== '' && cat.tag !== t('UNAV_CAT_NO_TAG') ? cat.tag + ' - ' : ''} ${cat.name} ${cat.customId ? ' (ID: ' + cat.customId + ')' : ''}`.trim(),
        //     isVacation: cat.vacation,
        //     archived: cat.archived,
        //     groupTitle: cat.id ? t('TIMEOFFS') : t('TIME_PREFERENCES'),
        //   }))
        const timeOffCategories = availableCategories.filter((cat) => cat.groupTitle === (0, util_1.t)('TIMEOFFS'));
        const timePreferencesCategories = availableCategories.filter((cat) => cat.groupTitle === (0, util_1.t)('TIME_PREFERENCES'));
        availableCategories.sort((a, b) => ('' + a.label).localeCompare(b.label));
        const addNewCategory = isEmployeeCalendar || isPreventedByPlugin('editUnavailabilityCategories')
            ? []
            : canWrite(const_1.PERMISSIONS.WORKSPACE.TIMEOFFCATEGORIES)
                ? [
                    {
                        label: '+ ' + (0, util_1.t)('UNAV_ADD_NEW_CATEGORY'),
                        value: 'newCategory',
                        archived: false,
                        isVacation: false,
                        groupTitle: (0, maybe_unwrap_1.unwrapMaybe)((0, util_1.t)('TIMEOFFS')),
                    },
                ]
                : [];
        return [
            ...(isRequest ? [] : timePreferencesCategories),
            ...timeOffCategories,
            ...addNewCategory,
        ];
    }, [canWrite, isEmployeeCalendar, isPreventedByPlugin, workspace]);
    return options;
};
exports.useUnavailabilityCategoryOptions = useUnavailabilityCategoryOptions;
